exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".editor-slide-upload[data-v-dc7cd3d0]{margin-bottom:20px}.editor-slide-upload ::v-deep .el-upload--picture-card[data-v-dc7cd3d0]{width:100%;height:406px;line-height:400px;text-align:center;vertical-align:middle}.editor-slide-upload ::v-deep .el-upload--picture-card button[data-v-dc7cd3d0]{margin-top:180px}.editor-slide-upload ::v-deep .el-upload--picture-card img[data-v-dc7cd3d0]{max-width:400px;max-height:400px}", ""]);

// exports
